import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import "amfe-flexible";
import "@/styles/reset.css";

const app = createApp(App);
app.use(store);
app.use(router);
app.mount('#app');
